import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Container,
  Col,
  Form,
  Spinner,
  Dropdown,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import CustomNavbar from "../../../components/CustomNavbar";
import SidebarDashboard from "../../../components/SidebarDashboard";
import { getCompetencies } from "../../../redux/descriptorsProfiles/competencies/actions";
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";
import config from "../../../config";
import LinkDescargaListGD from "../../../components/gestorDocumental/LinkDescargaListGD";
import { getCompetenciesDesc } from "../../../redux/descriptorsProfiles/competenciesDesc/actions";

const MoCompetencies = () => {
  //* States
  const [show, setShow] = useState(true);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState("");

  // const { loaderCompetencies, competencies, competenciesFaild } = useSelector(
  //   (store) => store.competencies
  // );
  const {
    loaderCompetenciesDesc,
    competenciesDesc,
    competenciesDescError,
  } = useSelector((store) => store.competenciesDesc);
  //* variables
  const { email } = config.gestorDocumental;
  const dispatch = useDispatch();
  const pages = Math.ceil((competenciesDesc ? competenciesDesc.count : 0) / limit);
  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "nombre",
    desc: "Nombre",
  });
  const columns = [
    {
      Header: "Nombre",
      accessor: "nombre",
    },
    {
      Header: "Descripción",
      accessor: "descripcion",
    },
    {
      id: "clasificacion",
      Header: "Clasificacion",
      Cell: (value) =>
        value.row.original.list_clasificacion && value.row.original.list_clasificacion.length > 0 ?
        value.row.original.list_clasificacion[0].nombre : ''
    },
    {
      id: "fecha_creacion",
      Header: "Fecha de creación",
      Cell: (value) =>
        moment(value.row.original.fecha_creacion).format("DD/MM/YYYY"),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) =>
        value.row.original.list_archivo &&
        value.row.original.list_archivo.length > 0 ? (
          <div className="btn-group" role="group">
            <LinkDescargaListGD
              id={value.row.original.list_archivo[0].id}
              filters={{
                email: email,
                id: value.row.original.list_archivo[0].id_documento,
                llave: value.row.original.list_archivo[0].llave,
              }}
              origen={value.row.original.list_archivo[0].origen}
              cType={value.row.original.list_archivo[0].contentTypeGD}
            />
          </div>
        ) : null,
    },
  ];
  // const filters = [
  //   {
  //     id: "competencia_nombre",
  //     desc: "Nombre de competencia",
  //   },
  //   {
  //     id: "tipo_competencia_descripcion ",
  //     desc: "Descripción de tipo de competencia",
  //   },
  //   { id: "area_descripcion ", desc: "Descripción de área" },
  //   { id: "division_descripcion", desc: "Descripción de división" },
  //   { id: "clasificacion_nombre", desc: "Nombre de clasificación" },
  // ];
  const filters = [
    { id: "nombre", desc: "Nombre" },
    { id: "fecha_creacion", desc: "Fecha de creación" },
  ];
  //* Method
  const _getCompetencies = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getCompetenciesDesc({
        offset: offs,
        limit: lim,
        tipo_busqueda: tipoBusqueda.id,
        filter:
          tipoBusqueda.id === "fecha_creacion"
            ? filt !== ""
              ? !isNaN(filt)
                ? filt
                : `${filt.charAt(6)}${filt.charAt(7)}${filt.charAt(
                    8
                  )}${filt.charAt(9)}-${filt.charAt(3)}${filt.charAt(
                    4
                  )}-${filt.charAt(0)}${filt.charAt(1)}`
              : filt
            : filt,
      })
    );

  useEffect(() => {
    _getCompetencies();
  }, [dispatch]);

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.search.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getCompetencies(oOffset, limit, e.target.search.value);
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getCompetencies(oOffset, limit, oSearch);
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 className="text-black-50 m-0">Manual de competencias y Comportamientos MAN-16</h5>
            <Form onSubmit={onSearch}>
              <Form.Row className="justify-content-sm-end align-items-center flex-wrap">
                <Col>
                  <h6>
                    <b>Busqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="search"
                    type="search"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill mr-1"
                      onClick={() => seeAll()}
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Dropdown className="ml-3 mr-3">
                      <Dropdown.Toggle
                        variant="light"
                        className="btn-sm font rounded-pill"
                      >
                        <i className="material-icons">filter_list</i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {filters.map((item) => (
                          <Dropdown.Item
                            onClick={() => setTipoBusqueda(item)}
                            key={item.id}
                          >
                            {item.desc}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </ButtonGroup>
                </Col>
              </Form.Row>
            </Form>
          </div>
          {competenciesDescError && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {competenciesDescError}
            </Alert>
          )}
          {loaderCompetenciesDesc ? (
            <div className="d-flex justify-content-center mt-4">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : competenciesDesc && competenciesDesc.data.length > 0 ? (
            <>
              <Card className="border-0">
                <Card.Body className="px-1 px-sm-2">
                  <CustomTable columns={columns} data={competenciesDesc.data} />
                </Card.Body>
              </Card>
              <CustomPagint
                limit={limit}
                setLimit={setLimit}
                offset={offset}
                setOffset={setOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataLenght={competenciesDesc.count}
                pages={pages}
                pagFunc={_getCompetencies}
              />
            </>
          ) : (
            <Alert variant="info" className="my-4">
              Sin registros que mostrar.
            </Alert>
          )}
        </Container>
      </div>
    </>
  );
};

export default MoCompetencies;
